<script setup lang="ts">
import {computed, PropType} from 'vue';
import date from "@/helper/datetime/date";
import {floatFormat} from "@/helper/amountFormatter";
import {
    Employee,
    EmployeePlannedAbsenceConstraints,
    EmployeePlannedAbsenceConstraintsFragmentFragment
} from "@/graphql/generated/graphql";
import {IonChip, IonIcon} from "@ionic/vue";
import {warning} from "ionicons/icons";
import InlineSVG from "@/components/InlineSVG.vue";
import {KapitelIcon} from "@/helper/icon";

const props = defineProps({
    plannedAbsences: {
        type: Object as PropType<EmployeePlannedAbsenceConstraintsFragmentFragment>,
        required: true,
    },
    compact: {
        type: Boolean,
        required: false,
        default: false
    },
    chipped: {
        type: Boolean,
        default: true
    }
})

const vacationValue = computed(() => props.plannedAbsences.remainingUnplannedVacation || 0)
const vacationValid = computed(() => props.plannedAbsences.validMonth || undefined)

const text = computed(() => props.compact
    ? /*vacation icon + */ ` ${floatFormat(vacationValue.value)}d`
    : `Resturlaub: ${floatFormat(vacationValue.value)} (Stand ${vacationValid.value ? date.formatKapitelDate(vacationValid.value, 'MMMM y') : 'unbekannt'})`
)

</script>

<template>
    <IonChip :color="warning" v-if="chipped"><InlineSVG v-if="compact" :src="KapitelIcon.vacation"/>{{text}}</IonChip>
    <span v-else><IonIcon v-if="compact" :icon="KapitelIcon.vacation"/>{{text}}</span>
</template>

<style lang="scss">
</style>
